import Link from 'next/link';
import TrustpilotListWidget from 'components/TrustpilotListWidget';
import { ASSET_PREFIX, colors } from 'utils/constants';
import Chevron from 'components/Chevron';

const winnerImages = [
  `${ASSET_PREFIX}/images/iceland-raffle/winner-content/1.jpg`,
  `${ASSET_PREFIX}/images/iceland-raffle/winner-content/2.jpg`,
  `${ASSET_PREFIX}/images/iceland-raffle/winner-content/3.jpg`,
  `${ASSET_PREFIX}/images/iceland-raffle/winner-content/4.jpg`,
  `${ASSET_PREFIX}/images/iceland-raffle/winner-content/5.jpg`,
  `${ASSET_PREFIX}/images/iceland-raffle/winner-content/6.jpg`,
];

const TalkOfTownSection = ({ onViewFullTerms }) => (
  <div className="flexCentered">
    <div className="container">
      <div className="titleSection">
        <span className="spacedFont mobile" style={{ fontSize: '1.1em', marginTop: '1em', marginBottom: '1em' }}>
          Other DAYMADE <strong>Winners</strong>
        </span>
        <span className="spacedFont desktop" style={{ fontSize: '1.1em', marginTop: '0.5em' }}>
          Talk Of The <strong>Town</strong>
        </span>
      </div>

      <div className="columnLayout">
        <div className="winnerImages">
          <p className='desktop' style={{ textShadow: '1px 1px white', fontSize: '1.2rem', marginBottom: '1em' }}>
            Other DAYMADE winners
          </p>
          <div className="winnerImagesGrid">
            { winnerImages.map((image, i) =>
              <Link href="/winners" key={i}>
                <div className="winnerImage">
                  <img
                    src={image}
                    alt="DAYMADE winner"
                  />
                </div>
              </Link>
            )}
          </div>
        </div>

        <div className="separator" />

        <div className="trustpilotReviewsContainer">
          <p style={{ textShadow: '1px 1px white', fontSize: '1.2rem', marginBottom: '1em' }}>
            Reviews
          </p>
          <div style={{ backgroundColor: 'white', padding: '1em', borderRadius: '3px' }}>
            <TrustpilotListWidget />
          </div>
        </div>
      </div>

      <div onClick={onViewFullTerms} className="viewFullTermsLink">
        View full terms
        <Chevron
          direction="right"
          style={{
            marginLeft: '0.8em',
            verticalAlign: 'middle',
            display: 'inline',
            fontSize: '1.1em',
          }}
        />
      </div>
    </div>

    <style jsx>
      {`
      .flexCentered {
        width: 100%;
      }
      
      .container {
        width: 100%;
        padding: 2em;
        margin: 0 auto;
        max-width: 1000px;
      }
      
      .mobile {
        display: none;
      }
      
      .desktop {
        display: block;
      }
      
      .titleSection {
        font-size: 1.3rem;
        font-weight: bold;
        text-align: center;
        text-shadow: 2px 2px white;
        padding-top: 1.3em;
      }
      
      .columnLayout {
        margin-top: 2em;
        display: flex;
        justify-content: space-around;
      }
      
      .winnerImages {
        max-width: 40%;
        height: 100%;
        cursor: pointer;
      }
      
      .winnerImagesGrid {
        height: 524px;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-auto-rows: 1fr;
        grid-gap: 1em;
        row-gap: 1em;
      }
      
      .winnerImage {
        object-fit: cover;
        object-position: center;
        overflow: hidden;
      }
      
      .winnerImage img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
      
      .trustpilotReviewsContainer {
        width: 40%;
      }
      
      .separator {
        background-color: ${colors.primaryBrandGray};
        max-width: 2px;
        height: 450px;
        margin: auto 2em;
        align-self: stretch;
        justify-self: stretch;
      }
      
      .viewFullTermsLink {
        margin-top: 2em;
        cursor: pointer;
        font-style: italic;
        font-weight: 600;
        font-size: 1.2em;
        text-align: center;
      }
      
      @media(max-width: 850px) {
        .mobile {
          display: block;
        }
        
        .desktop {
          display: none;
        }
        
        .columnLayout {
          flex-direction: column;
        }
        
        .separator {
          display: none;
        }
        
        .trustpilotReviewsContainer {
          margin-top: 4em;
        }
        
        .trustpilotReviewsContainer, .winnerImages {
          text-align: center;
          width: 100%;
          max-width: 100%;
        }
      }
    `}
    </style>
  </div>
);

export default TalkOfTownSection;
